import { PaymentMethod } from 'src/utils/constants/cfdi';
import { TransactionsCategory } from 'src/utils/constants/transactions';
import * as Yup from 'yup';

export default Yup.object().shape({
  amount: Yup.number()
    .positive('SCHEMA_ERRORS.NUMBER_MUST_BE_GREATER_THAN_ZERO')
    .typeError('SCHEMA_ERRORS.NUMBER_REQUIRED')
    .required('SCHEMA_ERRORS.REQUIRED_FIELD'),
  comment: Yup.string().when('category', {
    is: TransactionsCategory.SURCHARGE,
    then: schema => schema.required('SCHEMA_ERRORS.COMMENT_REQUIRED')
  }),
  contract: Yup.object().required('SCHEMA_ERRORS.REQUIRED_FIELD'),
  category: Yup.string().required('SCHEMA_ERRORS.SELECT_VALUE'),
  periodId: Yup.number()
    .transform((value, originalValue) =>
      originalValue === '' ? undefined : value
    )
    .when('category', {
      is: category =>
        category === TransactionsCategory.RENT ||
        category === TransactionsCategory.UPFRONT_RENT,
      then: schema => schema.required('SCHEMA_ERRORS.REQUIRED_FIELD')
    }),
  continueBilling: Yup.string().when('category', {
    is: TransactionsCategory.UPFRONT_RENT,
    then: schema => schema.required('SCHEMA_ERRORS.REQUIRED_FIELD')
  }),
  paymentMethod: Yup.string().required('SCHEMA_ERRORS.REQUIRED_FIELD'),
  paymentForm: Yup.string().when('paymentMethod', {
    is: PaymentMethod.PUE,
    then: schema => schema.required('SCHEMA_ERRORS.REQUIRED_FIELD'),
    otherwise: schema => schema.nullable().notRequired()
  })
});
